interface BuildInfo {
  version: string;
  buildTime: string;
  commitHash: string;
  branch: string;
  environment: string;
}

// Obtener información del build desde variables de entorno o valores por defecto
export function getBuildInfo(): BuildInfo {
  const now = new Date();
  
  return {
    version: import.meta.env.VITE_APP_VERSION || '0.0.0',
    buildTime: import.meta.env.VITE_BUILD_TIME || now.toISOString(),
    commitHash: import.meta.env.VITE_COMMIT_HASH || 'dev',
    branch: import.meta.env.VITE_BRANCH || 'local',
    environment: import.meta.env.MODE || 'development'
  };
}

// Imprimir información de versión en consola
export function logVersionInfo(): void {
  const buildInfo = getBuildInfo();
  
  console.group('🚀 Kairos Application Info');
  console.log(`📦 Version: ${buildInfo.version}`);
  console.log(`🕒 Build Time: ${new Date(buildInfo.buildTime).toLocaleString()}`);
  console.log(`🔗 Commit: ${buildInfo.commitHash}`);
  console.log(`🌿 Branch: ${buildInfo.branch}`);
  console.log(`🌍 Environment: ${buildInfo.environment}`);
  console.log(`🔧 Mode: ${import.meta.env.MODE}`);
  console.log(`📱 User Agent: ${navigator.userAgent}`);
  console.groupEnd();
}

// Obtener versión como string simple
export function getVersionString(): string {
  const buildInfo = getBuildInfo();
  return `${buildInfo.version}-${buildInfo.commitHash.substring(0, 7)}`;
}

// Verificar si es una versión de desarrollo
export function isDevelopment(): boolean {
  return import.meta.env.MODE === 'development';
}

// Verificar si es una versión de producción
export function isProduction(): boolean {
  return import.meta.env.MODE === 'production';
}
